import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Col,
  Row,
  Label
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";

import { Form, Formik, Field } from "formik";
import RavenFormikField from "components/Common/RavenFormikField";
import * as Yup from "yup";

//Import Common Component
import {
  WarningModal,
} from "components/Common/CombinedComponents";
import {
  getInitValue,
  getInitValueNull,
} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

//Translate
import { withTranslation } from "react-i18next";
import { doPaymentPost, getTransactionProvisionLinkedAmounts, getTransactionProvisionSettleLinkedAmounts } from "store/actions";
let countForOnChange = 0
let countForAmountRemaining = 0

class DoPaymentRefundOperation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warningModal: false,
      partialRefund: true,
      refundRecord: {
        merchantId: this.props.selectedDataList.subMerchantId,
        orderId: this.props.selectedDataList.orderId,
        paymentId: this.props.selectedDataList.paymentId,
        apiKey: this.props.recordListByMerchantGuid[0]?.apiKey,
        conversationId: this.props.randomString,
        language: "tr",
        amount: this.props.selectedDataList.f004,
        currencyCode: this.props.selectedDataList.f049,
        transactionType: "REFUND"
      },
    }
    this.handleValidRecordSubmit = this.handleValidRecordSubmit.bind(this);
  }
  getCurrencyName(currencyNumericCode) {
    let array = this.props.currencyDefRecordList
      .filter(i => i.numericCode === currencyNumericCode)
      .map(x => x);

    if (array?.length) return array[0].currencyName;
    else return currencyNumericCode;
  }
  componentDidMount() {
    countForAmountRemaining = 0
    const { getTransactionProvisionLinkedAmounts, getTransactionProvisionSettleLinkedAmounts
    } = this.props;
    const record = {
      orderId: this.props.selectedDataList.orderId,
      merchantId: this.props.selectedDataList.subMerchantId,
      guid: this.props.selectedDataList.guid
    }
    if (this.props.selectedDataList.transactionSettleStatus == 0) {
      getTransactionProvisionLinkedAmounts(record)
    } else {
      getTransactionProvisionSettleLinkedAmounts(record)
    }

    const refundRecord = {
      merchantId: this.props.selectedDataList.subMerchantId,
      orderId: this.props.selectedDataList.orderId,
      paymentId: this.props.selectedDataList.paymentId,
      apiKey: this.props.recordListByMerchantGuid[0]?.apiKey,
      conversationId: this.props.randomString,
      language: "tr",
      amount: this.props.selectedDataList.f004,
      currencyCode: this.props.selectedDataList.f049,
      transactionType: "REFUND"
    }
    this.props.doPaymentSignRefund(refundRecord)

  }
  componentDidUpdate(prevProps) {
    const {recordList} = this.props;
    if (this.props.selectedDataList.f004 != this.state.refundRecord.amount && countForOnChange < 2) {
      this.props.doPaymentSignRefund(this.state.refundRecord)
      countForOnChange++
    }
    if (this.props.selectedDataList.f004 != this.props.recordListAmounts?.amount && this.state.partialRefund && countForAmountRemaining < 4) {
      let remainingAamount = this.props.selectedDataList.f004 - this.props.recordListAmounts?.amount
      const refundRecord = {
        merchantId: this.props.selectedDataList.subMerchantId,
        orderId: this.props.selectedDataList.orderId,
        paymentId: this.props.selectedDataList.paymentId,
        apiKey: this.props.recordListByMerchantGuid[0]?.apiKey,
        conversationId: this.props.randomString,
        language: "tr",
        amount: remainingAamount,
        currencyCode: this.props.selectedDataList.f049,
        transactionType: "REFUND"
      }
      this.props.doPaymentSignRefund(refundRecord)
      countForAmountRemaining++
    }
   
  }

  handleAmount = (e) => {
    let remainingAamount = (this.props.selectedDataList.f004 - this.props.recordListAmounts?.amount).toString()
    this.setState((prevState) => ({
      refundRecord: {
        ...prevState.refundRecord,
        amount: e.target.value === "" ? remainingAamount : e.target.value
      }
    }));
    countForOnChange--
  }

  showWarning = (messageKey) => {
    this.setState({ warningMessage: this.props.t(messageKey) });
    setTimeout(() => this.setState({ warningModal: true }), 500);
  };

  submitRefund = (values, amount) => {
    const { doPayment, toggle, recordListSignRefund, randomString } = this.props;
  
    const record = {
      orderId: values.orderId,
      merchantId: values.subMerchantId,
      conversationId: randomString,
      language: "tr",
      sign: recordListSignRefund.sign,
      paymentId: values.paymentId,
      transactionDetails: {
        transactionType: "REFUND",
        currencyCode: values.currencyCode,
        amount
      }
    };
  
    doPayment(record);
    toggle();
  };
  
  handleValidRecordSubmit = (values) => {
    const { f004 } = this.props.selectedDataList;
    const refundedAmount = this.props.recordListAmounts?.amount || 0;
    const refundAmount = parseFloat(this.state.refundRecord.amount);
    const remainingAmount = f004 - refundedAmount;
    const totalRefundAttempt = refundAmount + refundedAmount;
  
    if (refundAmount > f004) {
      return this.showWarning("refundAmountCannotBeGreaterThenOrginalAmount");
    }
  
    if (refundedAmount === f004) {
      return this.showWarning("cannotMakeRefundAnymore");
    }
  
    const isPartial = this.state.partialRefund;
  
    if (!isPartial && (remainingAmount + refundedAmount > f004)) {
      return this.showWarning("totalRefundAmountCannotBeGreaterThenTransactionAmount");
    }
  
    if (isPartial && totalRefundAttempt > f004) {
      return this.showWarning("totalRefundAmountCannotBeGreaterThenTransactionAmount");
    }
  
    const amountToRefund = isPartial ? refundAmount : remainingAmount;
    this.submitRefund(values, amountToRefund);
  };

  render() {
    const { warningModal, warningMessage } = this.state;

    const styles = {
      border: '2px solid rgba(0, 0, 0, 0.08)',
    };  
    const { record } = this.props;
    return (
      <React.Fragment>
        <WarningModal
          warningMessage={warningMessage}
          show={warningModal}
          onCloseClick={() => this.setState({ warningModal: false })}
        />
        <Formik
          enableReinitialize={true}
          initialValues={{
            orderId: getInitValue(record, record.orderId),
            paymentId: getInitValue(record, record.paymentId),
            f038: getInitValue(record, record.f038),
            bankUniqueReferenceNumber: getInitValue(record, record.bankUniqueReferenceNumber),
            cardNo: getInitValueNull(record, record.cardNo),
            insertDateTime: getInitValueNull(record, record.insertDateTime),
            currencyCode: getInitValue(record, record.f049),
            transactionCurrencyName: this.getCurrencyName(record.f049),
            f004: getInitValueNull(record, record.f004),
            subMerchantId: getInitValue(record, record.subMerchantId),
          }}
          onSubmit={values => {
            this.handleValidRecordSubmit(values);
          }}
        >
          {({ errors, touched, setFieldValue }) => (
            <Form onChange={dirty => {
              this.setState({ isEditedValue: dirty });
            }}
            >

              <fieldset>
                <Row style={{ padding: "0" }}>
                  <Card style={styles}>
                    <CardBody>
                      <Row>
                        <Col lg={3} className="col-6">
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"orderId"}
                              label={this.props.t("orderId")}
                              type="text"
                              setFieldValue={setFieldValue}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"paymentId"}
                              label={this.props.t("paymentId")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"f038"}
                              label={this.props.t("authorizationNumber")}
                              type="text"
                              setFieldValue={setFieldValue}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"bankUniqueReferenceNumber"}
                              label={this.props.t("bankUniqueReferenceNumber")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={3} className="col-6">
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"cardNo"}
                              label={this.props.t("cardNumber")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"insertDateTime"}
                              label={this.props.t("transactionDate")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} className="col-6">
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"f004"}
                              label={this.props.t("transactionAmount")}
                              type="text"
                              value={this.props.selectedDataList.f004}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label>
                              {this.props.t("refundAmount")}
                            </Label>
                            <Field
                              name="amount"
                              className={"form-control"}
                              type="text"
                              disabled={this.state.partialRefund}
                              onChange={(e) => this.handleAmount(e)}
                              placeholder={this.props.recordListAmounts != null ? this.props.selectedDataList.f004 - this.props.recordListAmounts?.amount : this.props.selectedDataList.f004}
                            />
                          </div>
                        </Col>
                        <Col lg={3} className="col-6">
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"transactionCurrencyName"}
                              label={this.props.t("transactionCurrency")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Col lg={3} >
                        <Col md={12} style={{ display: "block", marginTop: "10px" }}>
                          <div className="form form-check form-switch form-switch-md" style={{ marginTop: "10px" }}>
                            <Label className="form-label" >
                              {this.props.t("partialRefund")}
                              <Field
                                style={{ marginRight: "5px" }}
                                className="form-check-input"
                                name={"partialRefund"}
                                type="checkbox"
                                onClick={(e) => { this.setState((prevState) => ({ partialRefund: !prevState.partialRefund })); }}
                              />
                            </Label>
                          </div>
                        </Col>
                      </Col>
                    </CardBody>
                  </Card>
                </Row>
                <Col lg={12}>
                  <div
                    style={{
                      textAlign: "right",
                    }}
                  >
                    <button
                      type="submit"
                      className="btn btn-success save-event"
                      style={{ marginRight: "3px" }}

                    >
                      {this.props.t("update")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary save-customer"
                      disabled={false}
                      onClick={() =>
                        this.props.toggle()
                      }
                    >
                      {this.props.t("cancel")}
                    </button>
                  </div>
                </Col>
              </fieldset>
            </Form>
          )}
        </Formik>
      </React.Fragment >
    )
  }
}
DoPaymentRefundOperation.propTypes = {
  record: PropTypes.any,
  recordList: PropTypes.array,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
  currencyDefRecordList: PropTypes.any,
  isDetail: PropTypes.any,
  toggle: PropTypes.any,
  recordCompanyTypeDefList: PropTypes.array,
  doPayment: PropTypes.func,
  recordListByMerchantGuid: PropTypes.any,
  recordListSignRefund: PropTypes.any,
  randomString: PropTypes.any,
  selectedDataList: PropTypes.any,
  doPaymentSignRefund: PropTypes.any,
  getTransactionProvisionLinkedAmounts: PropTypes.func,
  getTransactionProvisionSettleLinkedAmounts: PropTypes.func,
  recordListAmounts: PropTypes.array
};

const mapStateToProps = ({ doPayment, transactionProvision }) => ({
  recordList: doPayment.recordList,
  recordListAmounts: transactionProvision.recordListAmount,
  error: doPayment.error


});

const mapDispatchToProps = dispatch => ({
  doPayment: (record) => dispatch(doPaymentPost(record)),
  getTransactionProvisionLinkedAmounts: (record) => dispatch(getTransactionProvisionLinkedAmounts(record)),
  getTransactionProvisionSettleLinkedAmounts: (record) => dispatch(getTransactionProvisionSettleLinkedAmounts(record))


});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(DoPaymentRefundOperation));